( function( $, window, document, undefined ) {

	$( document ).ready(function() {

		$('.js-vehicle-colors').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			autoplay: false,
		});

		$('.js-vehicle-gallery').slick({
			slidesToShow: 4,
			slidesToScroll: 2,
			arrows: false,
			dots: false,
			autoplay: false,
		});

	});

} )( jQuery, window, document );
